<template>

    <v-dialog v-model="show" width="500">

        <v-card>
            <v-toolbar color="error">
                <v-toolbar-title class="white--text">
                    {{ state.currentTitle }}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>{{ state.currentError }}</v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="show = false" class="error white--text">Ok</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>

</template>

<script>
    import ErrorStore from '@/ts/stores/ErrorStore'

    export default {
        name: 'ErrorDialog',
        data() {
            return {
                state: ErrorStore.state,
                show: false
            }
        },
        watch: {
            state: {
                handler() {
                    if (this.state.currentError) {
                        this.show = true
                    }
                },
                deep: true
            },
            show(val) {
                if (!val) {
                    ErrorStore.clearError()
                }
            }
        }
    }
</script>
